<mat-progress-bar
  mode="indeterminate"
  *ngIf="loading"
  style="height:5px;"></mat-progress-bar>

<div class="modal-container-root">
  <div
    mat-dialog-title
    class="modal-title modal-padding-title {{classModalTitle}}">
    <div class="modal-flex-title">{{modalTitle}}</div>
    <button
      mat-icon-button
      class="title-button"
      [disabled]="loading"
      (click)="handleDismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-padding-body">

    <ng-container *ngIf="formGroup; else modalContent">
      <form
        [formGroup]="formGroup"
        (ngSubmit)="handleSubmit()"
        autocomplete="off"
        novalidate>
        <ng-template *ngTemplateOutlet="modalContent"></ng-template>
      </form>

    </ng-container>

  </div>
</div>

<ng-template #modalContent>
  <mat-dialog-content>
    <ng-content></ng-content>
  </mat-dialog-content>

  <mat-dialog-actions *ngIf="!noActions">
    <div class="modal-buttons">
      <div class="modal-left-actions">
        <ng-container *ngTemplateOutlet="modalLeftActionsTemplate; context {}"></ng-container>
      </div>
      <div>
        <button
          class="modal-button"
          *ngIf="formType!=FormType.CONSULTAR&&!hideSave"
          [type]="formGroup?'submit':'button'"
          mat-flat-button
          color="primary"
          (click)="handleClickSave()"
          [disabled]="loading">
          <mat-icon>{{saveIcon}}</mat-icon>
          {{saveText}}
        </button>
      </div>
      <div>
        <button
          type="button"
          class="modal-button"
          color="primary"
          mat-stroked-button
          (click)="handleDismiss()"
          [disabled]="loading">
          {{formType==FormType.CONSULTAR ? returnText: cancelText}}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</ng-template>
